import { useWidgetsMutation } from './useWidgetsMutation';
import { useQueryClient } from '@tanstack/react-query';
export const useWidgetUpdateConfigMutation = () => {
    const { mutate, mutateAsync, ...mutation } = useWidgetsMutation();
    const queryClient = useQueryClient();
    const updated = ({ uuid, config }) => {
        const widgets = queryClient.getQueryData(['widgets']);
        const nextWidgets = [...(widgets || [])];
        const replacedIndex = nextWidgets.findIndex((widget) => widget.uuid === uuid);
        if (replacedIndex !== -1) {
            const replacedWidget = nextWidgets[replacedIndex];
            nextWidgets.splice(replacedIndex, 1, { ...replacedWidget, config });
        }
        return nextWidgets;
    };
    return {
        ...mutation,
        mutate: (data, options) => mutate(updated(data), options),
        mutateAsync: (data, options) => mutateAsync(updated(data), options),
    };
};
//# sourceMappingURL=useWidgetUpdateConfigMutation.js.map